import { GIFT } from '../constants';

const initialState = {
  error: null,
  gifts: [],
  createdGift: null,
  updatedGift: null,
  isLoadingGetGifts: false,
  isLoadingCreateGift: false,
  isLoadingUpdateGift: false,
};

const giftReducer = (state = initialState, action = {}) => {
  switch (action.type) {
  case GIFT.GET_GIFTS:
    return {
      ...state,
      isLoadingGetGifts: true,
    };
  case GIFT.GET_GIFTS_FAILURE:
    return {
      ...state,
      isLoadingGetGifts: false,
      error: action.payload,
    };
  case GIFT.GET_GIFTS_SUCCESS:
    return {
      ...state,
      isLoadingGetGifts: false,
      gifts: action.payload,
      error: null,
    };
  case GIFT.CREATE_GIFT:
    return {
      ...state,
      isLoadingCreateGift: true,
    };
  case GIFT.CREATE_GIFT_FAILURE:
    return {
      ...state,
      isLoadingCreateGift: false,
      error: action.payload,
    };
  case GIFT.CREATE_GIFT_SUCCESS:
    return {
      ...state,
      isLoadingCreateGift: false,
      createdGift: action.payload,
      error: null,
    };
  case GIFT.UPDATE_GIFT:
    return {
      ...state,
      isLoadingUpdateGift: true,
    };
  case GIFT.UPDATE_GIFT_FAILURE:
    return {
      ...state,
      isLoadingUpdateGift: false,
      error: action.payload,
    };
  case GIFT.UPDATE_GIFT_SUCCESS:
    return {
      ...state,
      isLoadingUpdateGift: false,
      updatedGift: action.payload,
      error: null,
    };
  case GIFT.CLEAN_GIFT:
    return {
      ...initialState,
    };
  default:
    return state;
  }
};

export default giftReducer;
